var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.statf_s0 { fill: #2dc9ad } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-workspace-stat-folders"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icons-workspace-stat-folders",
    className: "statf_s0",
    d: "m22 5h-9.4l-2.7-2.2c-0.6-0.5-1.3-0.8-2.1-0.8h-4.6c-1.5 0-2.7 1.2-2.7 2.7v13.9c0 1.5 1.2 2.7 2.7 2.7h18.8c1.5 0 2.7-1.2 2.7-2.7v-10.9c0-1.5-1.2-2.7-2.7-2.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolders);
export default __webpack_public_path__ + "static/media/folders.d9122baec918e15143fcab87ed0ba6e9.svg";
export { ForwardRef as ReactComponent };